import { jsx, jsxs } from "react/jsx-runtime";
import { Field } from "../private/Field/Field.mjs";
import { Fragment } from "react";
import { useField } from "@react-aria/label";
import { BaseSelect } from "./BaseSelect.mjs";
import { fixedForwardRef } from "../../utils/fixedForwardRef.mjs";
function DropdownInner(props, ref) {
  const { disabled, id, label, message: errorMessage, icon: primaryIcon, ...restProps } = props;
  const field = useField({ ...props });
  return /* @__PURE__ */ jsx(
    Field,
    {
      ...field,
      ...restProps,
      message: errorMessage,
      id,
      label,
      labelId: void 0,
      prefix: void 0,
      secondaryMessage: null,
      disabled,
      icon: primaryIcon,
      children: (overlays, fieldProps, icon, secondaryIcon, prefix) => /* @__PURE__ */ jsxs(Fragment, { children: [
        icon,
        prefix,
        /* @__PURE__ */ jsx(
          BaseSelect,
          {
            name: props.id,
            fieldProps,
            isMulti: false,
            disabled,
            placeholder: label,
            ref,
            ...props
          }
        ),
        overlays,
        secondaryIcon
      ] })
    }
  );
}
const Dropdown = fixedForwardRef(DropdownInner);
export {
  Dropdown
};
